import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { CATEGORY_IMAGES } from "../../lib/constants";

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};
const item = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export function CategoryShowcase() {
  const navigate = useNavigate();

  return (
    <section className="py-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="category-showcase-section">
      <div className="flex items-end justify-between mb-10">
        <div>
          <span className="text-xs font-mono uppercase tracking-[0.25em] text-amber-light">Full Inventory Index</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase text-white mt-2">Shop By Category</h2>
        </div>
      </div>

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        className="grid grid-cols-2 md:grid-cols-4 gap-4"
      >
        {Object.entries(CATEGORY_IMAGES).map(([name, image]) => (
          <motion.button
            key={name}
            variants={item}
            onClick={() => navigate(`/catalog?category=${encodeURIComponent(name)}`)}
            data-testid={`category-card-${name.replace(/\s+/g, "-").toLowerCase()}`}
            className="group relative aspect-[4/5] overflow-hidden rounded-md border border-amber-500/10 text-left"
          >
            <img src={image} alt={name} loading="lazy" className="absolute inset-0 w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-110 transition-all duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
            <span className="absolute bottom-4 left-4 font-heading font-bold text-white text-sm sm:text-base uppercase tracking-wide">{name}</span>
          </motion.button>
        ))}
      </motion.div>
    </section>
  );
}
